module.exports = __webpack_public_path__ + "img/view-star-animation-2.5c2ac11b.png";